import presentationApi from '../../api/presentationApi';
import userApi from '../../api/userApi';
import firebaseApp from '../../api/firebaseClient';

const storeState = {
  allPresented: {},
  broadcasting: false,
  draftPresentedIds: [],
  currentDraftId: undefined,
  currentDraftSlides: undefined,
  currentPresentedSlide: null
};

const storeGetters = {
  isBroadcasting: state => state.broadcasting,
  draftPresented: (state) => {
    const presentationsList = [];
    state.draftPresentedIds.forEach((draftPresentationId) => {
      presentationsList.push(Object.assign(
        {
          presentationId: draftPresentationId
        },
        state.allPresented[draftPresentationId]
      ));
    });

    return presentationsList;
  },
  currentDraft: state => Object.assign(
    {},
    state.allPresented[state.currentDraftId],
    { presentationId: state.currentDraftId }
  ),
  currentDraftSlides: state => state.currentDraftSlides,
  currentPresentedSlide: state => state.currentPresentedSlide
};

const actions = {
  startBroadcasting({ commit }) {
    commit('SET_BROADCASTING', true);
  },

  stopBroadcasting({ commit }) {
    commit('SET_BROADCASTING', false);
  },

  getDraftPresentedPresentations({ commit, getters }) {
    presentationApi.fetchPresentedPresentations(getters.userId).then((presentedSnapshot) => {
      if (!presentedSnapshot.empty) {
        presentedSnapshot.forEach((presentationDoc) => {
          const presentationData = presentationDoc.data();
          if (presentationData.draft === true) {
            commit('UPDATE_DRAFT_PRESENTED_PRESENTATION', {
              presentationId: presentationDoc.id,
              presentationData
            });
          }
        });
      }
    });
  },

  createOrUpdatePresentation({ commit, getters }, formData) {
    if (formData.attendedId) {
      // update
    } else {
      presentationApi.getUniqueCheckinId().then((checkinId) => {
        const presentationData = Object.assign(
          formData,
          {
            checkinId,
            draft: true,
            currentSlide: 0,
            presenter: {
              name: getters.displayName,
              userId: getters.userId
            }
          }
        );

        presentationApi.createPresentation(presentationData).then((reference) => {
          userApi.addAttendance({
            presentationId: reference.id,
            createDate: firebaseApp.firebase.firestore.Timestamp.now(),
            presented: true
          });

          commit('UPDATE_DRAFT_PRESENTED_PRESENTATION', {
            presentationId: reference.id,
            presentationData
          });
          commit('SET_CURRENT_DRAFT', reference.id);
          commit('SYSTEM_MESSAGE', 'Successfully created presentation');
        });
      });
    }
  },

  setCurrentDraft({ commit }, presentationId) {
    commit('SET_CURRENT_DRAFT', presentationId);
  },

  storeSlides({ commit }, { presentationId, slides }) {
    presentationApi.updatePresentation(presentationId, { slides });
    commit('UPDATE_DRAFT_PRESENTED_SLIDES', slides.length ? slides : undefined);
  },

  setCurrentSlide({ commit, getters }, currentSlide) {
    presentationApi.updatePresentation(getters.currentDraft.presentationId, {
      currentSlide
    });
    commit('SET_PRESENTED_CURRENT_SLIDE', currentSlide);
  }
};

const mutations = {
  SET_BROADCASTING(state, broadcasting) {
    state.broadcasting = broadcasting;
  },
  UPDATE_DRAFT_PRESENTED_PRESENTATION(state, { presentationId, presentationData }) {
    if (state.draftPresentedIds.indexOf(presentationId) === -1) {
      state.draftPresentedIds.push(presentationId);
      state.allPresented[presentationId] = presentationData;
      state.currentDraftSlides = presentationData.slides;
    }
  },
  SET_CURRENT_DRAFT(state, presentationId) {
    state.currentDraftId = presentationId;
    if (!presentationId) {
      state.currentDraftSlides = undefined;
    }
  },
  UPDATE_DRAFT_PRESENTED_SLIDES(state, slides) {
    state.currentDraftSlides = slides;
  },
  SET_PRESENTED_CURRENT_SLIDE(state, currentSlide) {
    state.currentPresentedSlide = currentSlide;
  }
};

export default {
  state: storeState,
  getters: storeGetters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/presenter.js